/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";

/**
 * Standard error response object
 */
export type PutApiWorkspaceServiceV1WorkspaceSharingsErrorResponseData = {
  error: string;
  code?: string | undefined;
  details?: any | null | undefined;
};

/**
 * Standard error response object
 */
export class PutApiWorkspaceServiceV1WorkspaceSharingsErrorResponse
  extends Error
{
  error: string;
  code?: string | undefined;
  details?: any | null | undefined;

  /** The original data that was passed to this error instance. */
  data$: PutApiWorkspaceServiceV1WorkspaceSharingsErrorResponseData;

  constructor(err: PutApiWorkspaceServiceV1WorkspaceSharingsErrorResponseData) {
    const message = "message" in err && typeof err.message === "string"
      ? err.message
      : `API error occurred: ${JSON.stringify(err)}`;
    super(message);
    this.data$ = err;

    this.error = err.error;
    if (err.code != null) this.code = err.code;
    if (err.details != null) this.details = err.details;

    this.name = "PutApiWorkspaceServiceV1WorkspaceSharingsErrorResponse";
  }
}

/** @internal */
export const PutApiWorkspaceServiceV1WorkspaceSharingsErrorResponse$inboundSchema:
  z.ZodType<
    PutApiWorkspaceServiceV1WorkspaceSharingsErrorResponse,
    z.ZodTypeDef,
    unknown
  > = z.object({
    error: z.string(),
    code: z.string().optional(),
    details: z.nullable(z.any()).optional(),
  })
    .transform((v) => {
      return new PutApiWorkspaceServiceV1WorkspaceSharingsErrorResponse(v);
    });

/** @internal */
export type PutApiWorkspaceServiceV1WorkspaceSharingsErrorResponse$Outbound = {
  error: string;
  code?: string | undefined;
  details?: any | null | undefined;
};

/** @internal */
export const PutApiWorkspaceServiceV1WorkspaceSharingsErrorResponse$outboundSchema:
  z.ZodType<
    PutApiWorkspaceServiceV1WorkspaceSharingsErrorResponse$Outbound,
    z.ZodTypeDef,
    PutApiWorkspaceServiceV1WorkspaceSharingsErrorResponse
  > = z.instanceof(PutApiWorkspaceServiceV1WorkspaceSharingsErrorResponse)
    .transform(v => v.data$)
    .pipe(z.object({
      error: z.string(),
      code: z.string().optional(),
      details: z.nullable(z.any()).optional(),
    }));

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PutApiWorkspaceServiceV1WorkspaceSharingsErrorResponse$ {
  /** @deprecated use `PutApiWorkspaceServiceV1WorkspaceSharingsErrorResponse$inboundSchema` instead. */
  export const inboundSchema =
    PutApiWorkspaceServiceV1WorkspaceSharingsErrorResponse$inboundSchema;
  /** @deprecated use `PutApiWorkspaceServiceV1WorkspaceSharingsErrorResponse$outboundSchema` instead. */
  export const outboundSchema =
    PutApiWorkspaceServiceV1WorkspaceSharingsErrorResponse$outboundSchema;
  /** @deprecated use `PutApiWorkspaceServiceV1WorkspaceSharingsErrorResponse$Outbound` instead. */
  export type Outbound =
    PutApiWorkspaceServiceV1WorkspaceSharingsErrorResponse$Outbound;
}
